import styled from '@emotion/styled';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { GoalCategoryWithSubcategories } from 'src/modules/goals/models/goals';
import { Modal } from 'src/shared/components/Modal';
import { color, font, layout, mediaQueries } from 'src/shared/styles/variables';

const CategoryItemHolder = styled('div')({
    width: '33%',
    padding: '1rem',
    [mediaQueries.md]: {
        width: '50%',
    },
    [mediaQueries.sm]: {
        width: '100%',
    },
});

const CategoryTitle = styled('h3')(
    {
        color: color.bayOfMany,
        marginBottom: '0.5rem',
    },
    font.heavy(font.size.medium),
);

const CategoryTopics = styled('ul')({
    listStyleType: 'none',
    padding: 0,
});

const CategoryTopic = styled('li')(
    {
        color: color.tundora,
        lineHeight: 1.3,
        marginBottom: '0.25rem',
    },
    font.light(font.size.base),
);

interface CategoryItemProps {
    name: string;
    image: string;
    subcategories: string[];
}

const CategoryItem: React.SFC<CategoryItemProps> = ({ name, subcategories }) => (
    <CategoryItemHolder key={name}>
        <CategoryTitle>{name}</CategoryTitle>
        <CategoryTopics>
            {subcategories.map(subcategory => (
                <CategoryTopic key={subcategory}>{subcategory}</CategoryTopic>
            ))}
        </CategoryTopics>
    </CategoryItemHolder>
);

const StyledModal = styled(Modal)({
    '& .ant-modal-content': {
        maxWidth: layout.modalWidth.wide,
        margin: '0 auto',

        '& .ant-modal-body': {
            padding: '3rem 2rem 2rem',
        },
    },
});

const ModalHeader = styled('h3')(
    {
        color: color.bayOfMany,
        textAlign: 'left',
        marginLeft: '2rem',
        marginBottom: '1rem',
    },
    font.heavy(font.size.header),
);

const CategoriesList = styled('ul')({
    display: 'flex',
    flexWrap: 'wrap',
    padding: '0 1rem',
});

interface Props {
    visible: boolean;
    goalCategories: GoalCategoryWithSubcategories[];
    onToggle: () => void;
}

export const InformationModal: React.FC<Props> = ({ goalCategories, onToggle, visible }) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <StyledModal visible={visible} onCancel={onToggle} footer={null} width="auto">
                <ModalHeader>{t('onboarding:information_modal.examples')}</ModalHeader>
                <CategoriesList>
                    {goalCategories.map(category => (
                        <CategoryItem
                            key={category.id}
                            name={category.name}
                            image={category.image}
                            subcategories={category.subcategories}
                        />
                    ))}
                </CategoriesList>
            </StyledModal>
        </React.Fragment>
    );
};
